var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlightTakeoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4943 9.56865H0.869279C0.525529 9.56865 0.244279 9.8499 0.244279 10.1937C0.244279 10.5374 0.525529 10.8187 0.869279 10.8187H11.4943C11.838 10.8187 12.1193 10.5374 12.1193 10.1937C12.1193 9.8499 11.838 9.56865 11.4943 9.56865ZM12.4755 3.71865C12.338 3.21865 11.8255 2.9249 11.3255 3.05615L8.00678 3.94365L3.96928 0.181154C3.80053 0.0186537 3.55678 -0.0375963 3.33178 0.0249037C2.90678 0.143654 2.70678 0.631154 2.92553 1.0124L5.07553 4.7374L1.96928 5.56865L0.988029 4.79365C0.831779 4.6749 0.631779 4.63115 0.438029 4.68115L0.231779 4.7374C0.031779 4.7874 -0.0619709 5.01865 0.0442791 5.19365L1.21928 7.2249C1.36303 7.46865 1.65053 7.5874 1.91928 7.51865L11.8068 4.86865C12.3068 4.73115 12.6068 4.21865 12.4755 3.71865Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightTakeoff);
export default __webpack_public_path__ + "static/media/flight-takeoff.29f8027ab0cc1db172363259b6204406.svg";
export { ForwardRef as ReactComponent };